import axios from 'axios';
import { getItem } from '../utils/localStorage';
import {
  allLearningModulesPath,
  learningModulePath,
  fetchStandardsPath,
  fetchQuizCorrectAnswerPath,
  completeModulePath,
  fetchLearningModuleQuestionsPath,
  fetchStandardsCustomScoresPath,
} from '../utils/endpoints';
import { CreateDataByIndexedDB, GetAllDataByIndexedDB } from '../indexed';
import axiosInstance from '../helpers/interceptor';
import { userHotelDetails } from '../helpers/handleBrandAndHotelData';
import { Nullable } from '../app/@types/genericTypes';
import { IBoostersResponse } from '../app/@types/boosters';

export const fetchLearningModule = async (moduleId) => {
  return axiosInstance.get(`${learningModulePath}/${moduleId}`);
};

export const fetchAllModules = async () => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    allLearningModulesPath,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(allLearningModulesPath);

    dataD = data;
    CreateDataByIndexedDB(allLearningModulesPath, dataD, selectedHotel);
  }

  return dataD;
};
// STANDARDS

export const fetchStandardsCustomScoreTypes = async () => {
  const { selectedHotel } = userHotelDetails();

  return axiosInstance.get(
    `${fetchStandardsCustomScoresPath}/${selectedHotel}/customScoreTypes`
  );
};

const fetchStandards = (standardType): Promise<any> => {
  const { selectedBrand } = userHotelDetails();
  return axiosInstance.get(
    `${fetchStandardsPath}/${selectedBrand}/${standardType}`
  );
};

export const getStandardsByType = async (
  standardType: Nullable<string | number>
) => {
  const { user } = getItem('user');
  let brandId = 0;
  if (user && user.brands && user.brands.length && user.brands[0].id) {
    brandId = user.brands[0].id;
  }
  const selectedHotel = getItem('selectedHotel');
  let standardsResponse: any = [];
  const apiUrl = `${fetchStandardsPath}/${brandId}/${standardType}`;
  const uid = await GetAllDataByIndexedDB(apiUrl, selectedHotel);
  if (uid) {
    standardsResponse = uid;
  } else {
    const { data } = await fetchStandards(standardType);
    standardsResponse = data;
    CreateDataByIndexedDB(apiUrl, standardsResponse, selectedHotel);
  }
  return standardsResponse;
};

// QUIZZES
export const fetchQuestionsByModule = async (moduleId: number) => {
  return axiosInstance.get(fetchLearningModuleQuestionsPath, {
    params: {
      moduleId,
    },
  });
};

export const fetchCorrectAnswerId = async (questionId: string | number) => {
  const { accessToken } = getItem('user');

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  return await axios.post(
    fetchQuizCorrectAnswerPath,
    {
      questionId,
    },
    {
      headers,
    }
  );
};

export const completeModule = async (
  moduleId: string | number,
  score: string | number
) => {
  const { accessToken } = getItem('user');

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };

  return await axios.post(
    completeModulePath,
    {
      moduleId,
      score,
    },
    {
      headers,
    }
  );
};

// BOOSTERS
export const fetchWeeklyBoosters = async (
  department: string
): Promise<IBoostersResponse> => {
  const { data } = await axiosInstance.get<IBoostersResponse>(
    `${Env.API_URL}/weeklyBooster/current`,
    {
      params: {
        department,
      },
    }
  );
  return data;
};

export const markWeeklyBoosterAsViewed = async (
  boosterId: string,
  department: string
): Promise<void> => {
  const { data } = await axiosInstance.post(
    `${Env.API_URL}/weeklyBooster/view`,
    {
      boosterId,
      department,
    }
  );
  return data;
};
